export default {"src":"/_next/static/media/loader.d103fbf6.gif","height":256,"width":256,"blurWidth":0,"blurHeight":0};